import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { CgProfile } from "react-icons/cg";
import { FiLogOut } from "react-icons/fi";
import {
  IoChatbubbleEllipsesOutline,
  IoSettingsOutline,
} from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../app/hooks";
import { logout } from "../../features/authSlice";
import firstLetterUpperCase from "../../helpers/firstLetterUpperCase";
import { GrNotification } from "react-icons/gr";

type props = {
  userAvatar: string;
  firstName: string;
  lastName: string;
  notification: number;
  userType: string;
  clearNotification: () => void;
};

const UserMenu = ({
  notification,
  firstName,
  lastName,
  userAvatar,
  userType,
  clearNotification,
}: props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogOut = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      dispatch(logout());
      navigate("/");
    } catch (err) {
      console.error("failed to log out:", err);
    }
  };

  return (
    <div className="flex justify-center gap-6 items-center">
      <div className="relative">
        <GrNotification
          onClick={() => {
            clearNotification();
            navigate("/notifications");
          }}
          className="text-[#212121] text-xl cursor-pointer"
        />
        {notification > 0 && (
          <div className="absolute h-4 -top-2 left-2   w-4 text-center text-white text-xs rounded-full bg-red-400">
            {notification}
          </div>
        )}
      </div>

      <Menu>
        <MenuButton className="font-bold  flex items-center justify-start w-auto relative">
          <img
            src={userAvatar}
            className="w-9 h-9 rounded-full me-4"
            alt="default-avatar"
          />
          {notification > 0 && (
            <div className="absolute h-3 -top-1 -left-1 w-3 rounded-full bg-orange-400"></div>
          )}
          {`  ${firstName && firstLetterUpperCase(firstName || " ")}`}
        </MenuButton>
        <MenuItems className="flex w-56  flex-col space-y-6 z-10 absolute top-72 md:top-20 bg-white rounded-2xl px-5 py-9 text-gray-400 font-['poppins'] font-semibold">
          <MenuItem>
            {({ active }) => (
              <Link
                className={`${
                  active && "text-orange-400"
                } flex space-x-3 items-center`}
                to="/userProfile"
              >
                <CgProfile className="me-1 text-2xl" />
                Profile
              </Link>
            )}
          </MenuItem>
          <MenuItem>
            {({ active }) => (
              <Link
                className={`${
                  active && "text-orange-400"
                } flex space-x-3 items-center`}
                to="/settings"
              >
                <IoSettingsOutline className="me-1 text-2xl" />
                Settings
              </Link>
            )}
          </MenuItem>
          {/* {userType !== "apprentice" && (
          <MenuItem>
            {({ active }) => (
              <Link
                className={`${
                  active && "text-orange-400"
                } flex space-x-3 items-center`}
                to="/userJobHistory"
              >
                <RiHistoryFill className="me-1 text-2xl" />
                Job History
              </Link>
            )}
          </MenuItem>
        )} */}

          <MenuItem>
            {({ active }) => (
              <Link
                className={`relative inline-block ${
                  active && "text-orange-400"
                } flex space-x-3 items-center`}
                to="/chats"
                onClick={clearNotification}
              >
                <IoChatbubbleEllipsesOutline className="me-1 text-2xl " />
                Chats
                {notification > 0 && (
                  <div className="absolute h-4 -top-3 left-16 w-4 text-center text-white text-xs rounded-full bg-orange-400">
                    {notification}
                  </div>
                )}
              </Link>
            )}
          </MenuItem>
          <MenuItem>
            <hr />
          </MenuItem>
          <MenuItem>
            {({ active }) => (
              <Link
                className={`${
                  active && "text-orange-400"
                } flex space-x-3 items-center`}
                to="/logout"
                onClick={handleLogOut}
              >
                <FiLogOut className="me-1 text-2xl" />
                Logout
              </Link>
            )}
          </MenuItem>
        </MenuItems>
      </Menu>
    </div>
  );
};

export default UserMenu;
